module.exports = __webpack_public_path__ + "media/images/mime_types/file-o-bbc1eabf178f0f024e5af1c7a9c12323.png";